// src/components/TopupSuccess.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';

const TopupSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [details, setDetails] = useState({
    phone: '',
    amount: '',
    paymentId: '',
    timestamp: ''
  });

  useEffect(() => {
    const phone = searchParams.get('phone') || '';
    const amount = searchParams.get('amount') || '';
    const paymentId = searchParams.get('payment_id') || '';
    
    setDetails({
      phone,
      amount,
      paymentId,
      timestamp: new Date().toLocaleString()
    });

    if (phone) {
      localStorage.setItem('userPhoneNumber', phone);
    }

    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 10000);

    return () => clearTimeout(timer);
  }, [searchParams, navigate]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="p-d-flex p-jc-center p-ai-center p-mt-6 p-p-3" style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Card className="p-shadow-4" style={{ width: '500px', maxWidth: '100%' }}>
        <div className="p-d-flex p-flex-column p-ai-center p-gap-3">
          {/* Success Icon */}
          <div className="p-d-flex p-jc-center p-ai-center" 
               style={{ 
                 width: '80px', 
                 height: '80px', 
                 borderRadius: '50%', 
                 background: '#22C55E',
                 animation: 'pulse 2s infinite'
               }}>
            <i className="pi pi-check" style={{ fontSize: '3rem', color: 'white' }}></i>
          </div>

          <h2 className="p-m-0" style={{ color: '#22C55E' }}>Payment Successful!</h2>
          <p className="p-text-secondary p-m-0 p-text-center">
            Your wallet has been credited successfully
          </p>

          <Divider />

          {/* Payment Details */}
          <div className="p-d-flex p-flex-column p-gap-2" style={{ width: '100%' }}>
            <div className="p-d-flex p-jc-between p-ai-center p-py-1" style={{ borderBottom: '1px solid #f0f0f0' }}>
              <span className="p-text-secondary">Phone Number</span>
              <span className="p-text-bold">{details.phone || 'N/A'}</span>
            </div>
            <div className="p-d-flex p-jc-between p-ai-center p-py-1" style={{ borderBottom: '1px solid #f0f0f0' }}>
              <span className="p-text-secondary">Amount Added</span>
              <Tag severity="success" value={formatCurrency(details.amount || 0)} />
            </div>
            <div className="p-d-flex p-jc-between p-ai-center p-py-1" style={{ borderBottom: '1px solid #f0f0f0' }}>
              <span className="p-text-secondary">Payment ID</span>
              <span className="p-text-small" style={{ fontSize: '0.8rem', color: '#6B7280' }}>
                {details.paymentId || 'N/A'}
              </span>
            </div>
            <div className="p-d-flex p-jc-between p-ai-center p-py-1">
              <span className="p-text-secondary">Time</span>
              <span className="p-text-small">{details.timestamp}</span>
            </div>
          </div>

          <Divider />

          <div className="p-d-flex p-flex-column p-gap-2" style={{ width: '100%' }}>
            <Button
              label="Go to Dashboard"
              icon="pi pi-home"
              className="p-button-success"
              style={{ width: '100%' }}
              onClick={() => navigate('/dashboard')}
            />
            <Button
              label="View Wallet"
              icon="pi pi-wallet"
              className="p-button-outlined"
              style={{ width: '100%' }}
              onClick={() => navigate('/wallet')}
            />
          </div>

          <p className="p-text-secondary p-m-0" style={{ fontSize: '0.8rem' }}>
            <i className="pi pi-clock p-mr-1"></i>
            Redirecting to dashboard in a few seconds...
          </p>
        </div>
      </Card>

      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default TopupSuccess;